import { useEffect, useRef } from "react";
import { useDispatch } from 'react-redux';

import { setStateScrolling } from "../../../../../actions/index";

const useListScroll = () => {
  const dispatch = useDispatch();
  let ref = useRef(null);
  const onScroll = (e) => {
    if (e.currentTarget.firstChild && ref && ref.current) {
      dispatch(setStateScrolling((e.currentTarget.firstChild.getBoundingClientRect().y < ref.current.getBoundingClientRect().y)));
    }
  }

  // No need anymore
  // const onWheel = (e) => {
  //   const atTop = e.currentTarget.scrollTop === 0;
  //   const atBottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
  //   if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
  //     e.preventDefault();
  //     const parent = e.currentTarget.parentElement.parentElement.parentElement.parentElement; // 'global-page'
  //     parent.scrollBy({
  //       top: e.deltaY,
  //       left: 0,
  //       behavior: 'smooth'
  //     });
  //   }
  // }

  useEffect(() => {
    return () => { dispatch(setStateScrolling(false)); }
  }, [dispatch])

  return { ref, onScroll };
};

export default useListScroll;
